import type { EvolutionAttachedPrintable, EvolutionReturnWorkflow } from './evolutionWorkflowTypes';

export function normalizeEvolutionProcedureLabels(evo: any): string[] {
  const pp = evo?.procedures_performed;
  if (!Array.isArray(pp)) return [];
  return pp.map((p: any) => (typeof p === 'string' ? p.trim() : String(p?.name || p?.label || '').trim())).filter(Boolean);
}

export function getEvolutionWorkflowPrintables(evo: any): EvolutionAttachedPrintable[] {
  const raw = evo?.metadata?.evolution_workflow?.printables;
  if (!Array.isArray(raw)) return [];
  return raw.filter((p: unknown) => p && typeof (p as EvolutionAttachedPrintable).templateName === 'string');
}

/**
 * Rótulo para listagens sem coluna «tipo» (timeline do paciente, etc.).
 * Receitas antigas só tinham «Simples — fármaco»; assim fica evidente que é um receituário.
 */
export function evolutionPrintableListLabel(p: EvolutionAttachedPrintable): string {
  const raw = String(p.templateName || '').trim();
  if (p.category !== 'prescription') return raw || 'Documento';
  if (!raw) return 'Receituário';
  if (/^receitu[aá]?rio(\s|$|[—\-–])/i.test(raw)) return raw;
  return `Receituário — ${raw}`;
}

export function getEvolutionReturnWorkflow(evo: any): EvolutionReturnWorkflow | null {
  const r = evo?.metadata?.evolution_workflow?.return;
  if (!r || typeof r !== 'object') return null;
  return r as EvolutionReturnWorkflow;
}

/** Retorno combinando checkboxes (metadata) + notas livres na evolução. */
export function formatEvolutionReturnWorkflowLines(wf: EvolutionReturnWorkflow | null): string[] {
  if (!wf) return [];
  const bits: string[] = [];
  if (wf.returnWithExams) bits.push('Retorno com exames');
  if (wf.returnForSurgery) bits.push('Retorno para cirurgia');
  if (wf.dischargeNoRecall) bits.push('Alta — não reconvocar');
  const rin = String(wf.returnInDays || '').trim();
  const reeval = String(wf.reevaluationInDays || '').trim();
  if (rin) bits.push(`Retorno em ${rin} dia(s)`);
  if (reeval) bits.push(`Reavaliação em ${reeval} dia(s)`);
  return bits;
}

export function evolutionViewerHasWorkflowReturn(evo: any): boolean {
  return formatEvolutionReturnWorkflowLines(getEvolutionReturnWorkflow(evo)).length > 0;
}

export function evolutionViewerHasFollowUpSection(evo: any): boolean {
  if (String(evo?.follow_up_notes || '').trim()) return true;
  if (evo?.follow_up_date) return true;
  return evolutionViewerHasWorkflowReturn(evo);
}
